import { useState, useEffect } from 'react';
import { FiMenu, FiX, FiArrowUpRight } from 'react-icons/fi';

const links = [['#services', 'Inicio'], ['#habitaciones', 'Habitaciones'], ['#espacioscomunes', 'Espacios'], ['#servicioscomunes', 'Servicios'], ['#tarifas', 'Tarifas'], ['#ubicacion', 'Ubicación'], ['#footer', 'Contacto']];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const close = (event) => { if (event.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, []);
  return (
    <header className="site-header">
      <a className="skip-link" href="#contenido">Ir al contenido</a>
      <nav className="site-nav" aria-label="Navegación principal">
        <a className="hotel-brand" href="#services" onClick={() => setOpen(false)}><span>Hotel Raglan<small>MAR DEL PLATA</small></span></a>
        <button className="menu-toggle" type="button" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={open} aria-controls="site-links" onClick={() => setOpen(!open)}>{open ? <FiX /> : <FiMenu />}</button>
        <div id="site-links" className={`site-links ${open ? 'is-open' : ''}`}>
          {links.map(([href, label]) => <a key={href} href={href} onClick={() => setOpen(false)}>{label}</a>)}
        </div>
        <a className="nav-book" href="#consulta">Consultá tu estadía <FiArrowUpRight aria-hidden="true" /></a>
      </nav>
    </header>
  );
}
